module.exports = __webpack_public_path__ + "lp/img/zoom_out_disabled.9c0ac53a.svg";